import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    marginTop: 10,
    "& .MuiForm-underline:after": {
      borderBottomColor: "#778899"
    },
    "& .MuiAutocomplete-input": {
      fontSize: 12
    }
  },
  labelStyle: {
    fontSize: 14
  },
  tag: {
    background: "#FFF",
    color: "#304967",
    border: "1px solid #DADADA",
    height: 20,
    "& svg.MuiChip-deleteIcon": {
      height: 18,
      width: 18,
      margin: 0
    }
  }
}));

const DataSelect = ({
  keyField = "id",
  dataSource,
  onChange,
  value,
  disabled,
  readOnly,
  label,
  multiple,
  classes,
  disableClearable = true,
  filterSelectedOptions,
  getOptionLabel,
  ...rest
}) => {
  const { container, labelStyle, tag } = useStyles();

  const returnFunction = dataSource => {
    if (multiple) {
      return dataSource.filter(i => value.some(v => (keyField === "_key") ? (v._key === i._key) : (v.id === i.id)));
    } else {
      return dataSource.find(i => (keyField === "_key") ? i._key === value : i.id === value) || "";
    }
  };

  return (
    <Autocomplete
      disabled={!dataSource || dataSource.length === 0 || disabled || readOnly}
      disableClearable={disableClearable}
      options={dataSource}
      classes={{ root: container, tag }}
      multiple={multiple}
      filterSelectedOptions={filterSelectedOptions}
      value={returnFunction(dataSource)}
      onChange={(e, value) => {
        if (value) onChange(value);
        else if (!multiple) {
          value = (keyField === "_key") ? { _key: null } : { id: null };
          onChange(value);
        }
      }}
      getOptionLabel={getOptionLabel || (option => (option && option!="") ? option.name : '')}
      {...rest}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          fullWidth
          InputLabelProps={{ shrink: true, classes: { root: labelStyle } }}
        />
      )}
      closeText="Закрыть список"
      openText="Открыть список"
      clearText="Очистить"
      loadingText="Загрузка..."
      noOptionsText="Нет доступных вариантов"
    />
  );
};

export default DataSelect;
